import Model from "./base/model";

class OrderCollectionAddress extends Model{
  resourceName() {
    return "order_collection_addresses";
  }

  fields() {
    return {
      observation: "",
      address_id: "",
      street: "",
      number: "",
      district: "",
      postal_code:"",
      complement:"",
      city_id:"",
      city:"",
      state:"",
      uf:"",
      latitude: "",
      longitude: "",
      collection_real_date_time: "",
      real_date_time_justification: "",
      collection_status: "",
      expected_collection_date_time: "",
      map_url: "",
      destinatary_name: "",
      destinatary_identification_document: "",
      is_natural_person: "",
    };
  }

  async collect(id, data) {
    return this.request(
      "orders/" + this.resourceName() + "/collect/" + id,
      "POST",
      {},
      data,
    );
  }
}

export default new OrderCollectionAddress();
